import FastInvSvg from "../assets/icons/fast-investment.svg";
import GrowthSvg from "../assets/icons/growth.svg";
import DiverseSvg from "../assets/icons/diverse.svg";

export const GLOBAL_CONSTANTS = {
  FORGOT_PWD: "Forgot Password?",
  NEW_USER: "New User?",
  COUNTRY_CODE: "+91",
  COMPLETE_KYC_TXT: "Complete KYC Verification",
  KYC_UNDER_REVIEW_TXT:
    "KYC under review. You will be notified once it's done!",
  SLA_NOT_SIGNED_TXT: "SLA is not Signed",
  BOARD_RES_PENDING_TXT: "Board Resolution Pending",
  BOARD_RES_REJECTED_TXT: "Board Resolution Rejected. Please upload again.",
  BOARD_RES_UNDER_REVIEW_TXT: "Board Resolution under review.",
  ALREADY_HAVE_ACC: "Already have an Account?",
  REVIEW_MSG_TITLE: "Review in Progress",
  REVIEW_MSG_DESC:
    "We are reviewing your documents. Please visit again after some time.",
  SUCCESS: "success",
  KYC_SUCCESS_MSG: "Your KYC process has been successfully completed.",
  SUPPORT_EMAIL: "support@karncy.com",
  WHATSAPP_NUM: "9703676999",
  EMPTY_DASH_TITLE_TXT: "Your Dashboard is empty. Start investing today!",
  EMPTY_DASH_DESC_TXT:
    "Investors have gained strong returns through high-value deals, making Karncy a trusted platform for profitable investments.",
  DEALS_BANNER_TXT1: "Investors are actively funding high-value deals,",
  DEALS_BANNER_TXT2: "reflecting strong confidence in the Karncy platform.",
  MIN_AMT_TO_INV_TXT: "A Minimum of ₹2,00,000 Required to invest in deals.",
  SHARE_TXT: "Share details via",
  WHATSAPP: "WhatsApp",
  EMAIL: "Email",
  WAL_BAL: "Wallet Balance",
  MIN_BAL_TO_BUY_DEAL: 200000,
  JV_KARNCY_CARRY_PERCENT: 20,
  STAT_PEN_ID: "USM1000007",
  STAT_KYC_PEN_ID: "USM1000008",
  STAT_KYC_REVIEW_ID: "USM1000010",
  STAT_KYC_VERIFIED_ID: "USM1000009",
  STAT_REJECTED_ID: "USM1000006",
  STAT_ACTIVE_ID: "USM1000001",
  KAR_NAME: "Karta Name",
  NAME_AS_PER_PAN: "Name as per PAN",
  KAR_EMAIL: "Karta Email",
  KAR_PH_NUM: "Karta Phone Number",
  PH_NUM: "Phone Number",
  PRIM_ADD: "Primary Address",
  COMM_ADD: "Address for Communication",
  NA: "Not Available",
  NIL: "Nil",
  COMP_NAME: "Company Name",
  NBFC_NAME: "NBFC Name",
  COMP_EMAIL: "Company Email",
  NBFC_EMAIL: "NBFC Email",
  COMP_PH_NUM: "Company Phone Number",
  NBFC_PH_NUM: "NBFC Phone Number",
  DESIG: "Designation",
  IND_TYPE: "Industry Type",
  COMP_TYPE: "Company Type",
  NBFC_TYPE: "NBFC Type",
  ANN_TURN: "Annual Turnover",
  COMP_REG_ADD: "Company Registered Address",
  NBFC_REG_ADD: "NBFC Registered Address",
  DIR_NAME: "Director Name",
  DOB: "Date of Birth",
  DIR_EMAIL: "Director Email",
  DIR_PH_NUM: "Director Phone Number",
  HUF_NAME: "HUF Name",
  HUF_EMAIL: "HUF Email",
  HUF_PH_NUM: "HUF Phone Number",
  HUF_REG_ADD: "HUF Registered Address",
  DEL: "Delete",
  DEL_BANK_CONFIRM: "Are you sure you want to delete this bank account?",
  MARK_AS_PRI: "Mark as Primary",
  ACC_NUM: "Account Number",
  ACC_HOL_NAME: "Account Holder Name",
  ACC_IFSC: "Account IFSC",
  BRA_NAME: "Branch Name",
  PRIM_BANK: "PRIMARY BANK",
  CONCENT_PROV:
    "I provide my consent to karncy to verify my bank details and store in this platform",
  TERMS_COND_PRIV_POL:
    "I here by read and accept Terms and Conditions, Refund Policies and Privacy Policies",
  NBFC_PAN: "NBFC PAN",
  NBFC_GSTIN: "NBFC GSTIN",
  NBFC_BANK_ACC: "NBFC Bank Account",
  COMP_PAN: "Company PAN",
  COMP_GSTIN: "Company GSTIN",
  COMP_BANK_ACC: "Company Bank Account",
  DIR_PAN: "Director PAN",
  DIR_AADHAR: "Director Aadhar",
  PAN: "PAN",
  HUF_PAN: "HUF PAN",
  KAR_PAN: "Karta PAN",
  AADHAR: "Aadhar",
  BANK_ACC: "Bank Account",
  SLA: "SLA",
  BR: "Board Resolution",
  NOM_LEG_NAME: "Nominee Legal Name",
  NOM_DOB: "Nominee Date of Birth",
  RELSHIP: "Relationship",
};

export const BTN_TXT = {
  LOGIN: "Login",
  SIGNUP: "Sign Up",
  SEND_OTP: "Send OTP",
  BACK: "Back",
  CHANGE: "Change",
  RESEND_OTP: "Resend OTP",
  NEXT: "Next",
  SUBMIT: "Submit",
  SHARE: "Share",
  ADD_MON: "Add Money",
  MORE: "More",
  PROFILE: "Profile",
  BANK_DET: "Bank Details",
  CHNG_PWD: "Change Password",
  LOGOUT: "Logout",
  COMPLETE_NOW: "Complete Now",
  SIGN_SLA: "Sign SLA",
  SKIP: "Skip",
  COMPLETE: "Complete",
  PROCEED_FURTHER: "Proceed Further",
  MAYBE_LATER: "May be Later",
  LETS_START_BTN_TEXT: "Let's get started!",
  SUP_FAQ: "Support & FAQ",
  PRI_POL: "Privacy Policy",
  TERM_COND: "Terms and Conditions",
  REFUND_POL: "Refund Policy",
  VERIFY_OTP: "Verify OTP",
  ADD_NEW_BANK: "Add New Bank",
  SAVE: "SAVE",
  EDIT: "Edit",
  SAVE_CHNG: "Save Changes",
  SAVE_ADD: "Save Address",
  EXP_DEALS: "Explore Deals",
  READ_LESS: "Read Less",
  READ_MORE: "Read More",
  VIEW_ALL: "View All",
  CLICK_HERE: "Click here",
  TO_VIEW_DETAILS: "to view the details",
  CANCEL: "Cancel",
  DELETE: "Delete",
  UPLOAD_NOW: "Upload Now",
  REUPLOAD: "Re-upload",
  SWITCH_MANUAL: "Switch to Manual Upload",
  SUBMIT_FOR_REVIEW: "Submit for Review",
  UPLOADING: "Uploading...",
  CLICK_TO_UPLOAD: "Click to Upload",
  RESUBMIT_KYC: "Re-submit KYC",
};

export const TITLE_TXT = {
  WELCOME_TEXT: "Welcome to Karncy",
  OTP_TITLE: "Enter the OTP",
  CHNG_PWD_TITLE: "Change Password",
  SIGNUP_AS_TITLE: "I want to sign up as ..",
  INV: "Investor",
  VEN: "Vendor",
  ENROLL_AS: "Enroll me as a...",
  LETS_GET_START_TEXT: "Let's get started!",
  RM_DET_TXT: "Your RM Details",
  DEAL_BOOKED: "Deal Booked",
  DEAL_EXEC: "Deal Executed",
  DEAL_DIS: "Deal Disbursed",
  REPAYMENT: "Repayment",
  REPAID: "Repaid",
  ECW_DET_TXT: "Your Virtual Account Details",
  ECW_BEN_ACC_NAME: "Beneficiary Account Name",
  ECW_BANK_NAME: "Virtual Account Bank Name",
  ECW_BRANCH_NAME: "Virtual Account Branch Name",
  ECW_BANK_ACC_NUM: "Virtual Account Number",
  ECW_IFSC_CODE: "Virtual Account IFSC Code",
  DEPO_DET_TO_EMAIL_CONFIRM_TXT:
    "Are you sure you want to send the deposit details to your email?",
  DEPO_DET_TO_WHATSAPP_CONFIRM_TXT:
    "Are you sure you want to send the deposit details to your Whatsapp?",
  REVIEW_INFO_TITLE: "We are reviewing your documents",
  PER_DETS: "Personal Details",
  KAR_DETS: "Karta Details",
  COMP_DETS: "Company Details",
  NBFC_DETS: "NBFC Details",
  AUTH_SIG: "Authorized Signatory",
  HUF_DETS: "HUF Details",
  BANK_DETS: "Bank Details",
  ADD_NEW_BANK_DETS: "Add New Bank Details",
  ECW_DETS: "Virtual Account Details",
  KYC_DETS: "KYC Details",
  NOM_DETS: "Nominee Details",
  ADD_NOM_DETS: "Add your Nominee Details",
  EDIT_NOM_DETS: "Edit your Nominee Details",
  YOUR_DASH: "Your Dashboard",
  IND_INV: "Industries you have invested",
  MANUAL_KYC_TITLE: "Manual Document Upload",
  MANUAL_STEP1_TITLE: "Identity & Address Verification",
  MANUAL_STEP1_KARTA_TITLE: "Step 1: Karta Identity & Address Verification",
  MANUAL_STEP1_DIRECTOR_TITLE: "Step 1: Director Identity & Address Verification",
  MANUAL_STEP1_IDENTITY_TITLE: "Step 1: Identity & Address Verification",
  MANUAL_STEP2_TITLE: "Business / Entity Verification",
  MANUAL_STEP2_HUF_FORM_TITLE: "HUF Verification",
  MANUAL_STEP2_HUF_TITLE: "Step 2: HUF Verification",
  MANUAL_STEP2_ENTITY_TITLE: "Step 2: Business & Entity Verification",
  MANUAL_STEP2_BANK_TITLE: "Step 2: Bank Account Verification",
  MANUAL_STEP3_TITLE: "Bank Account Verification",
  MANUAL_STEP3_BANK_TITLE: "Step 3: Bank Account Verification",
  KYC_REJECTED_TITLE: "KYC Verification Rejected",
  HV_UNAVAILABLE_TITLE: "Verification Service Unavailable",
  HV_DECLINED_TITLE: "verification is declined",
};

export const DESC_TXT = {
  ECW_DET_TXT:
    "Please transfer amount to your Virtual Account to start investing",
  FORGOT_PWD_INFO_TEXT:
    "Enter your user account's verified email address and we will send an otp to that email.",
  OTP_INFO_TEXT:
    "If you have not received the OTP in your inbox, please check your Junk/Spam folder as well.",
  POC_DIRECTOR_NOTE:
    "The POC Name, POC Phone Number, and POC Email ID must be the details of a Director of the investor.",
  INV_DESC:
    "Grow your money while supporting businesses! Fund invoices and earn returns as businesses repay.",
  VEN_DESC:
    "Need quick cash flow for your business? Sell your invoices, get instant funds, and keep growing",
  RM_DET_NOT_AVAIL: "RM details not available",
  AWAT_APP_BY_BUS: "Awaiting approval by Karncy",
  AWAT_SIGN_AGG: "Awaiting Business & Karncy sign-off",
  REVIEW_INFO_DESC: "Please visit again after some time.",
  BANK_DETS_NOT_AVAIL: "Bank details not available",
  ECW_DETS_NOT_AVAIL: "Virtual Account details not available",
  MANUAL_KYC_DESC: "Verification service is temporarily unavailable. Please upload your documents manually for admin review.",
  MANUAL_REVIEW_DESC: "Your documents have been submitted and are under manual review by our team. We will notify you once verification is complete.",
  MANUAL_STEP1_DESC: "Upload your PAN card, proof of identity (Aadhaar), and a selfie photo.",
  MANUAL_STEP2_DESC: "Upload your GSTIN certificate or Company/HUF PAN card.",
  MANUAL_STEP2_HUF_DESC: "Upload your HUF PAN card details.",
  MANUAL_STEP3_DESC: "Enter your bank account details and upload a cancelled cheque or bank statement.",
  HV_UNAVAILABLE_DESC:
    "The automated verification service is temporarily unavailable. You can continue with manual document upload.",
  HV_DECLINED_DESC:
    "Your verification is Failed. Please verify your details again",
};

export const SUCCESS_MSGS = {
  ECW_DET_SUC_MSG: "Virtual Account details sent to registered email Sucessfully!",
};

export const ERROR_MSGS = {
  SESSION_ELSEWHERE:
    "You have been logged out because your account was signed in elsewhere.",
  EMAIL_ERR_MSG: "Email cannot be empty!",
  PWD_ERR_MSG: "Password cannot be empty!",
  DESIGNATION_ERR_MEG: "Designation cannot be empty!",
  BANK_KYC_ERR_MSG: "Please Complete your bank verification later",
  ENTER_CURR_PWD_ERR_MSG: "Please enter your current password!",
  ACC_NUM_ERR_MSG: "Account numbers do not match!",
  ACCP_CONCENT_ERR_MSG: "You must agree to the consent letter!",
  ENTER_NOM_DOB: "Please enter Nominee DOB!",
  SEL_REL: "Please select your relationship!",
  ACCP_TER_CON: "You must accept the terms and conditions!",
  SEL_STATE: "Please select State!",
  SEL_IND_TYPE: "Please select Industry Type!",
  SEL_ANN_TURN: "Please select Annual Turnover!",
  SEL_COMP_TYPE: "Please select Company type!",
};

export const USERTYPE_ID = {
  INDIVIDUAL: "UTY1000001",
  HUF: "UTY1000002",
  ENTITY: "UTY1000006",
  NBFC: "UTY1000008"
};

export const KYC_MODE = {
  MANUAL: "MANUAL",
  DIGITAL: "DIGITAL",
};

export const MANUAL_KYC_STEP_STATUS = {
  PENDING: "PENDING",
  SUBMITTED: "SUBMITTED",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
  NOT_APPLICABLE: "NOT_APPLICABLE",
};

export const MANUAL_KYC_ID_TYPE = "aadhaar";

export const MANUAL_KYC_UPLOAD_ACCEPT =
  "image/jpeg,image/png,image/webp,application/pdf,.jpg,.jpeg,.png,.webp,.pdf";

export const MANUAL_KYC_UPLOAD_HINT = "JPEG, PNG, WEBP or PDF (max 5 MB)";

export const KYC_SESSION_KEYS = {
  MODAL_PROCEEDED: "kyc_modal_proceeded",
};

export const MANUAL_KYC_MSG = {
  SELFIE_REQUIRED: "Please take a live selfie before submitting.",
  PAN_DOC_REQUIRED: "Please upload your PAN document.",
  AADHAAR_DOC_REQUIRED: "Please upload your Aadhaar document.",
  BANK_PROOF_REQUIRED:
    "Please upload bank proof (cancelled cheque or bank statement).",
  HUF_PAN_DOC_REQUIRED: "Please upload HUF PAN document.",
  ENTITY_PAN_DOC_REQUIRED: "Please upload entity PAN document.",
  GST_DOC_REQUIRED: "Please upload GST certificate.",
  STATE_REQUIRED: "State is required.",
  BRANCH_REQUIRED: "Branch name is required.",
  CONFIRM_ACC_REQUIRED: "Please confirm your account number.",
  ACC_MISMATCH: "Account numbers do not match.",
  SUBMIT_FAILED: "Failed to submit. Please try again.",
  SUBMIT_ERROR: "An error occurred during submission.",
  SUBMISSION_FAILED: "Submission failed.",
  REJECT_DEFAULT: "Rejected during manual review",
  STEP_SAVED: (step) => `Step ${step} details saved successfully!`,
  RESUBMIT_STEP1: "Re-submit Step 1 (Identity & Address)",
  RESUBMIT_STEP2_HUF: "Re-submit Step 2 (HUF PAN)",
  RESUBMIT_STEP2_ENTITY: "Re-submit Step 2 (Business Details)",
  RESUBMIT_STEP2_BANK: "Re-submit Step 2 (Bank Account)",
  RESUBMIT_STEP3_BANK: "Re-submit Step 3 (Bank Account)",
};

export const MANUAL_KYC_LABELS = {
  AADHAAR_NUMBER: "Aadhaar Number",
  AADHAAR_PLACEHOLDER: "Enter 12-digit Aadhaar number",
  AADHAAR_DOCUMENT: "Aadhaar Document",
  ADDRESS_LINE_1: "Address Line 1",
  ADDRESS_LINE_2: "Address Line 2",
  CITY: "City",
  STATE: "State",
  PINCODE: "Pincode",
  GSTIN: "GSTIN",
  GST_CERTIFICATE: "GST Certificate",
  ACCOUNT_NUMBER: "Account Number",
  CONFIRM_ACCOUNT_NUMBER: "Confirm Account Number",
  IFSC: "IFSC Code",
  ACCOUNT_HOLDER: "Account Holder Name",
  BANK_NAME: "Bank Name",
  BRANCH_NAME: "Branch Name",
  BRANCH_PINCODE: "Branch Pincode",
  BANK_PROOF: "Cancelled Cheque / Bank Statement",
  PAN: "PAN Number",
  KARTA_PAN: "Karta PAN Number",
  DIRECTOR_PAN: "Director PAN Number",
  FULL_NAME_PAN: "Full Name as per PAN",
  FULL_NAME_KARTA_PAN: "Full Name as per Karta PAN",
  FULL_NAME_DIRECTOR_PAN: "Full Name as per Director PAN",
  SELFIE: "Selfie Photo",
  KARTA_SELFIE: "Karta Selfie Photo",
  DIRECTOR_SELFIE: "Director Selfie Photo",
  HUF_PAN: "HUF PAN Number",
  ENTITY_PAN: "Company / NBFC PAN Number",
  HUF_PAN_DOC: "HUF PAN Document",
  ENTITY_PAN_DOC: "Company / NBFC PAN Document",
  REGISTERED_ADDRESS_1: "Registered Address Line 1",
};

export const ABOUT_KARNCY = {
  KARNCY_USERS_DESC:
    "Join a global community of users who grow their wealth with Karncy.",
  ABOUT_LIST_DATA: [
    {
      title:
        "Fast and secure investments - Fund invoices and enjoy quick reliable returns",
      icon: FastInvSvg,
    },
    {
      title:
        "Smart wealth growth - Grow your wealth by helping businesses access working capital.",
      icon: GrowthSvg,
    },
    {
      title:
        "Stable earnings, diversified portfolio - Reduce risks with verified invoice-backed investments.",
      icon: DiverseSvg,
    },
  ],
  TESTIMONIALS: {
    NAME: "Venkat Jammi, President, OTM Labs",
    RATING: 5,
    REVIEW: `OTM Labs is a software company with a subsidiary in India focused on SAP services. Over the past eight years, OTM has provided reliable service and achieved healthy profit margins in its Indian operations. By investing its surplus funds in fixed deposits, OTM earned an average annual return of 5% to 6%.

When KARCNY proposed an investment opportunity with a fixed assured return of 15%, OTM began investing in their debt fund, which offers quarterly interest payouts and the flexibility to recall funds with 90 days' notice. This investment supported OTM with an average return of 14% over the past two years, making our operations smooth and cost-effective.

Whether you are an SME looking for funds or an investor looking for low-risk, high-yield short-term returns, KARCNY can be your answer.`,
  },
};

export const ACCOUNT_TYPE = {
  NORMAL: "normal",
  POOLING: "pooling",
  PLATFORM: "platform",
};

export const HYPERVERGE_STATUS = {
  AUTO_APPROVED: "auto_approved",
  NEEDS_REVIEW: "needs_review",
  MANUALLY_DECLINED: "manually_declined",
};

export const HYPERVERGE_WORKFLOW_IDS = {
  MOB_WFLOW_ID: "karncy_emailotp",
  KYC_WFLOW_ID: "karncy_onboarding",
  GSTIN_WFLOW_ID: "sf9rjL_02_12_24_19_13_15",
  PAN_WFLOW_ID: "pan_only",
  BANK_WFLOW_ID: "karncy_bankVerification",
};

export const KYC_TYPE = {
  MBL: "MBL",
  KYC: "KYC",
  GST: "GST",
  PAN: "PAN",
  BNK: "BNK",
};

export const GET_KYC_STEPS = (isHUF, isCompany, isNbfc) => {
  const steps = [
    {
      title: "KYC",
      content: "Complete your KYC by uploading the required documents.",
    },
  ];

  if (isHUF) {
    steps.push({
      title: "HUF PAN Verification",
      content: "Add your HUF PAN details to complete the process.",
    });
    steps.push({
      title: "Bank Verification",
      content: "Add your HUF bank details to complete the process.",
    });
  } else if (isCompany || isNbfc) {
    steps.push({
      title: "GSTIN Verification",
      content: "Add your GSTIN details to complete the process.",
    });
    steps.push({
      title: "Bank Verification",
      content: `Add your ${isNbfc ? "VMF" : "Company"} bank details to complete the process.`,
    });
  } else {
    steps.push({
      title: "Bank Verification",
      content: "Add your bank details to complete the process.",
    });
  }

  return steps;
};

export const FAQ = {
  Q1: {
    Q: "What services does Karncy Offer?",
    A: "Karncy offers investment solutions that focus on wealth creation through asset-backed ventures with higher returns and lower risks. The platform is designed for users seeking secure, high-yield investments that are less dependent on market volatility.",
  },
  Q2: {
    Q: "How secure are investments made through Karncy?",
    A: "Karncy emphasizes security by offering asset-backed investments. The assets act as collateral, ensuring that investments are protected and carry less risk compared to typical market investments.",
  },
  Q3: {
    Q: "How is the risk assessed for each investment?",
    A: "Karncy conducts a thorough due diligence process for each asset-backed opportunity to evaluate risks, potential returns, and market conditions. This ensures that investors are provided with secure and profitable opportunities.",
  },
  Q4: {
    Q: "How does Karncy's investment model work?",
    A: "Karncy allows individuals to invest in opportunities backed by tangible assets, reducing market risk. This model enables users to diversify their portfolios into safer, high-return assets, while ensuring easy entry with a minimal learning curve.",
  },
  Q5: {
    Q: "How is Karncy different from other investment platforms?",
    A: "Karncy focuses on providing investment opportunities in asset-backed ventures that offer more stable and secure returns compared to volatile market-based platforms. This minimizes the risks typically associated with stock or bond investments.",
  },
  Q6: {
    Q: "What is the average return on investment (ROI) for Karncy users?",
    A: "The ROI varies depending on the asset and investment type, but Karncy focuses on providing higher returns compared to traditional savings or market investments due to their asset-backed nature.",
  },
  Q7: {
    Q: "How can I track the performance of my investments?",
    A: "Karncy provides an investor dashboard where users can monitor the performance of their assets in real time, view historical data, and track returns.",
  },
  Q8: {
    Q: "How quickly can I access returns on my investment?",
    A: "Investment returns may vary based on the assets and terms of the specific opportunity. Typically, returns are generated over a set period based on asset maturity and profitability.",
  },
  Q9: {
    Q: "How does Karncy handle market volatility?",
    A: "Karncy offers investments that are designed to be less dependent on market fluctuations. By focusing on tangible, asset-backed investments, it provides more stable returns regardless of market conditions.",
  },
  Q10: {
    Q: "What industries or assets does Karncy invest in?",
    A: "Karncy focuses on diverse sectors like real estate, manufacturing, and other asset-backed ventures to ensure stable and secure returns for investors.",
  },
};

export const SOCIAL_MEDIA_LINKS = {
  FB: "https://www.facebook.com/share/16QqocZRC6/",
  X: "https://x.com/Karncyfintech",
  LI: "https://www.linkedin.com/company/karncy",
};

export const dashFilterOptions = [
  { filterId: "ORV0004", filterName: "This Month vs last Month", comparisonText: "vs Last Month" },
  { filterId: "ORV0001", filterName: "Today", comparisonText: "vs Last Day" },
  { filterId: "ORV0006", filterName: "Yesterday", comparisonText: "vs Yesterday" },
  { filterId: "ORV0007", filterName: "Last 7 Days", comparisonText: "vs Previous 7 Days" },
  { filterId: "ORV0003", filterName: "Last 30 Days", comparisonText: "vs Previous 30 Days" },
  { filterId: "ORV0005", filterName: "This Month", comparisonText: "vs Last Month" },
  { filterId: "ORV0008", filterName: "This Quarter vs Previous Quarter", comparisonText: "vs Previous Quarter" },
  { filterId: "ORV0009", filterName: "This Year vs Last Year", comparisonText: "vs Last Year" },
  { filterId: "ORV0002", filterName: "Till now", comparisonText: "vs Last Month" },
];
